import { Directive } from '@angular/core';

@Directive({
  selector: '[cardToolbar]',
  standalone: true
})
export class CardToolbarDirective {
}
